import { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PrintIcon from '@mui/icons-material/Print';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { AppId } from '../../../app/appTypes';
import { Localized } from '@fluent/react';
import { Link, useNavigate } from 'react-router-dom';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import { useAppSelector } from '../../../app/hooks';
import { selectSettings } from '../../settings/settingsSlice';
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { DocumentExcelExporter } from '../../documents/components/DocumentExcelExporter';
import { Box } from '@mui/material';
import { GreenExcelIcon } from '../../../app/customIcons/ExcelIcon';

export interface UrsRequestToolbarMenuProps {
    usrRequestId: AppId
    usrId: AppId
}

export const UrsRequestToolbarMenu = ({ usrRequestId, usrId }: UrsRequestToolbarMenuProps) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { locale } = useAppSelector(selectSettings);
    const navigate = useNavigate();

    const [exportToExcel, setExportToExcel] = useState(false)
    const hadleExportToExcelClick = () => {
        setExportToExcel(true)
    }
    const handleCloseExportToExcel = () => {
        setExportToExcel(false)
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePrintUrsClick = async () => {
        setAnchorEl(null);
        if (usrRequestId) {
            window.open(`${process.env.REACT_APP_REST_API}api/reports/urs/${usrId}?language=${locale}`, '_blank')
        }
    }

    const handlePrintCommentedUrsClick = async () => {
        setAnchorEl(null);
        if (usrRequestId) {
            window.open(`${process.env.REACT_APP_REST_API}api/reports/urs-offer/${usrRequestId}?language=${locale}`, '_blank')
        }
    }

    const handlePrintMatchingUrsClick = async () => {
        setAnchorEl(null);
        if (usrRequestId) {
            window.open(`${process.env.REACT_APP_REST_API}api/reports/report/urs-request-matching/${usrRequestId}?language=${locale}`, '_blank')
        }
    }

    const handleMatchingReportClick = async () => {
        setAnchorEl(null);
        if (usrRequestId) {
            navigate(`/background-processes/URS_OFFER/${usrRequestId}`);

        }
    }

    return (
        <div>
            <Button
                aria-controls="menu"
                aria-haspopup="true"
                onClick={handleClick}
                variant="contained"
                color="primary"
                endIcon={<ArrowDropDownIcon />}
            >
                <Localized id="menu">
                    <span>Menu</span>
                </Localized>
            </Button>
            <Menu
                id="menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => handlePrintCommentedUrsClick()}>
                    <PrintIcon sx={{ mr: 1 }} />
                    <Localized id="urs-offer-action-print">
                        <span>Wydruk</span>
                    </Localized>
                </MenuItem>
                <MenuItem onClick={() => handlePrintUrsClick()}>
                    <PrintIcon sx={{ mr: 1 }} />
                    <Localized id="urs-offer-action-print-original">
                        <span>Wydruk</span>
                    </Localized>
                </MenuItem>
                <MenuItem onClick={() => handlePrintMatchingUrsClick()}>
                    <PrintIcon sx={{ mr: 1 }} />
                    <Localized id="urs-offer-matching-report">
                        <span>Matching report</span>
                    </Localized>
                </MenuItem>
                <MenuItem onClick={() => handleMatchingReportClick()}>
                    <HistoryEduIcon sx={{ mr: 1 }} />
                    <Localized id="urs-offer-matching-list">
                        <span>Matching report List</span>
                    </Localized>
                </MenuItem>
                <MenuItem onClick={hadleExportToExcelClick}>
                    <Box sx={{
                        mr: 1,
                        display: 'flex',
                        [`& svg`]: {
                            width: '24px',
                            height: '24px',
                        },
                    }}>
                        <GreenExcelIcon />
                    </Box>
                    <Localized id="export-to-excel">
                        <span>Eksportuj do excela</span>
                    </Localized>
                </MenuItem>
                {/* <MenuItem component={Link}
                    to={`/supplierOffers/edit/1`}
                >
                    <HistoryEduIcon sx={{ mr: 1 }} />
                    <span>Create offer (In progress)</span>
                </MenuItem> */}
            </Menu>
            {exportToExcel && <DocumentExcelExporter
                documentId={usrId}
                language=""
                mode={"open"}
                isDialogOpen={true}
                closeDialog={handleCloseExportToExcel}
            />
            }
        </div>
    );
};
